import { Grid } from '@material-ui/core';
import React from 'react';
import useStyles from '../Styles';
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';
import ToolbarButtons from './ToolbarButtons';

const Visuals = () => {
    const classes = useStyles();
    const { isMobile } = useGetViewPortDimensions();

    return (
        <Grid
          container
          justify='space-between'
          alignItems='center'
          className={classes.settingsVisualContainer}
          style={{ width: '100vw', zIndex: 20 }}
        >
          {
            isMobile  && (
              <>
                <ToolbarButtons />
              </>
            )
          }          
        </Grid>
    )
}

export default Visuals;
